import { useEffect } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';

/**
 * Recale les valeurs de référence du formulaire une fois toutes ses sections montées.
 *
 * Les formulaires de détail déclarent leurs valeurs initiales section par section (`register()` +
 * `defaultValue` sur l'input) : react-hook-form les voit dans les valeurs courantes mais pas dans
 * les `defaultValues` du `useForm`. Or `isDirty` vaut `!deepEqual(valeurs, defaultValues)` et est
 * recalculé à chaque rendu, donc le formulaire est considéré comme modifié dès l'ouverture de la
 * page (bouton « Mettre à jour » actif, popup « modifications non enregistrées » en sortie).
 *
 * Les effets du parent s'exécutant après ceux des enfants, l'état capturé ici contient déjà tout ce
 * que les sections ont enregistré : `isDirty` ne devient vrai qu'après une vraie saisie.
 */
export function useFormPristineBaseline<TFieldValues extends FieldValues>({
    getValues,
    reset,
}: Pick<UseFormReturn<TFieldValues>, 'getValues' | 'reset'>): void {
    useEffect(() => {
        // les valeurs courantes deviennent la référence, sans toucher à ce qui est affiché
        reset(getValues(), { keepValues: true });
    }, [getValues, reset]);
}
